import comprimir from 'browser-image-compression'

import { mensagemDeErro } from './utilitarios'

/** Acima disso o bucket 'fotos' recusa o upload (limite de 5 MB). */
const LIMITE_BUCKET_BYTES = 5 * 1024 * 1024

/**
 * Compressão no cliente antes do upload.
 *
 * Foto de celular sai com 3 a 8 MB. O bucket gratuito do Supabase tem
 * 1 GB, e a participante muitas vezes está no 4G — comprimir aqui é o
 * que mantém tanto o upload rápido quanto o custo em zero.
 *
 * A compressão roda num Web Worker (`useWebWorker: true`) para não
 * travar a interface numa foto grande. O preço disso: se o worker
 * falhar por qualquer motivo — memória, um formato que o navegador não
 * decodifica, CSP restritiva —, o erro que atravessa de volta a
 * fronteira do worker costuma perder o protótipo `Error`, e quem
 * capturar isso com `instanceof Error` nunca vê a causa real. Por isso
 * duas camadas de fallback aqui, em vez de deixar a falha subir crua:
 * tenta de novo sem worker, e se mesmo assim falhar, usa o arquivo
 * original — melhor uma foto sem compressão do que travar a
 * participante no meio do cadastro.
 */
export async function comprimirImagem(arquivo: File): Promise<File | Blob> {
  const opcoes = {
    maxSizeMB: 0.4,
    maxWidthOrHeight: 1400,
    fileType: 'image/webp',
    initialQuality: 0.82,
  }

  try {
    return await comprimir(arquivo, { ...opcoes, useWebWorker: true })
  } catch (erroWorker) {
    console.warn('Compressão via Web Worker falhou, tentando na thread principal:', erroWorker)
  }

  try {
    return await comprimir(arquivo, { ...opcoes, useWebWorker: false })
  } catch (erroThreadPrincipal) {
    console.warn(
      'Compressão falhou também na thread principal, enviando o arquivo original:',
      mensagemDeErro(erroThreadPrincipal),
    )
  }

  if (arquivo.size > LIMITE_BUCKET_BYTES) {
    throw new Error(
      'Essa foto é grande demais e eu não consegui comprimi-la. Tente uma foto diferente.',
    )
  }

  return arquivo
}
